<div fxLayout="row" fxLayoutAlign="center center" class="error-page-wrap">
  <mat-card class="error-card">

    <div class="error-hero" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <mat-icon class="error-hero-icon">lock</mat-icon>
      </div>
      <div class="error-hero-divider"></div>
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <h1 class="error-code">403</h1>
        <div class="error-status">{{ 'access-denied' | translate }}</div>
      </div>
    </div>

    <mat-card-content class="error-body" fxLayout="column" fxLayoutAlign="center center">
      <p class="error-message">{{ 'not-authorized-page' | translate }}</p>
      <div class="error-actions" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="16px">
        <button mat-stroked-button class="btn-outline-dark" type="button" (click)="goHome()">
          <mat-icon>home</mat-icon>
          {{ 'go-home' | translate }}
        </button>
        <button mat-stroked-button type="button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          {{ 'sign-out' | translate }}
        </button>
      </div>
    </mat-card-content>

  </mat-card>
</div>
